<nz-modal i18n-nzTitle [nzVisible]="isVisible" (nzOnOk)="onOk()" (nzOnCancel)="cancel()"
  nzTitle="How many buckets do you plan to produce?" i18n-nzOkText i18n-nzCancelText nzOkText="confirm"
  nzCancelText="cancel">
  <ng-container *nzModalContent>
    <nz-row>
      <nz-col nzSpan="12">
        <nz-slider [nzMin]="minCount" [nzMax]="maxCount" [(ngModel)]="value"></nz-slider>
      </nz-col>
      <nz-col nz-col nzSpan="4" style="margin-inline-start: 16px">
        <nz-input-number [nzMin]="minCount" [nzMax]="maxCount" [(ngModel)]="value"></nz-input-number>
      </nz-col>
    </nz-row>
  </ng-container>
</nz-modal>